import React, {useState} from 'react';
import PropTypes from 'prop-types';

const ToolButton = ({active, number, onClick, text}) => {
    const [hover, setHover] = useState(false);

    return (
        <div onClick={onClick}
             onMouseEnter={() => setHover(true)}
             onMouseLeave={() => setHover(false)}
             style={{
                 ...styles.container,
                 backgroundColor: active || hover ? '#e4195f' : '#00a499',
             }}>
            <div style={{
                ...styles.number,
                color: active || hover ? '#e4195f' : '#00a499',
            }}>{number}</div>
            <div style={styles.text}>
                {text}
            </div>
        </div>
    );
}

ToolButton.propTypes = {
    active: PropTypes.bool.isRequired,
    number: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
};

const styles = {
    container: {
        borderRadius: 8,
        cursor: 'pointer',
        height: '80px',
        width: '100%',
        marginLeft: '15px',
        marginRight: '15px',
    },
    number: {
        backgroundColor: '#ffffff',
        borderRadius: '23px',
        fontFamily: 'Ubuntu',
        fontSize: '26px',
        fontWeight: 500,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        height: '45px',
        width: '45px',
        marginTop: '20px',
        marginLeft: '20px',
    },
    text: {
        color: '#ffffff',
        display: 'flex',
        flexGrow: 1,
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'Ubuntu',
        fontSize: '24px',
        fontWeight: 500,
    },
};

export default ToolButton;
